import React, { Fragment, useState } from 'react'
import { Form, Input, Button, Space, Skeleton } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { postData } from '../../../Actions/Action'

function ConnectionSettingsComponent(props) {
	const [testType, setTestType] = useState(false)
	const dispatch = useDispatch()
    const { connectionSettings, token, carrierId, isInstalling } = useSelector(state => state)

	const handleTypeChange = type => setTestType(type)

	const onFinish = values => {
		values = {
			...values,
			testType,
			carrierId,
			installed_carrier_id: carrierId,
		}

		dispatch(
			postData(
				values,
				'GET_CONNECTION_SETTINGS',
				'submit_connection_settings',
				token
			)
		)
	}

	if (!connectionSettings) return <Skeleton active />

	return (
		<Fragment>
			<div className={'note-bx'}>
				<strong>Note!</strong> You must have a SAIA LTL Freight account to
				use this application. If you don’t have one, contact SAIA LTL Freight
				at +1 800-765-7242 or email{' '}
				<a
					href='mailto:customerservice@saia.com'
					target='_blank'
					rel='noreferrer'>
					customerservice@saia.com
				</a>{' '}
			</div>

			<Form
				layout='vertical'
				name='connection_settings'
				className='connection-settings'
				size='large'
				initialValues={connectionSettings}
				onFinish={onFinish}>
                <Form.Item
                    className='mb-1'
                    label='Nickname'
                    name='nickname'
                    required={true}
                    rules={[{ required: !testType, message: 'Nickname is required' }]}>
					<Input placeholder='e.g., SAIA' />
				</Form.Item>
				<Form.Item
					label='Account Number'
					name='account_number'
                    required={true}
                    rules={[{ required: testType, message: 'Account Number is required' }]}>
					<Input placeholder='Account Number' />
				</Form.Item>
				<Form.Item
					label='Account Number Postal Code'
					name='original_postal_code'
					required={true}
					rules={[
                        { required: testType, message: 'Account Number Postal Code is required' },
					]}>
					<Input placeholder='Account Number Postal Code' />
				</Form.Item>
				<Form.Item
					label='Third Party Account Number'
					name='third_party_account_number'>
					<Input placeholder='Third Party Account Number' />
				</Form.Item>
                <Form.Item
                    label='Username'
                    name='userID'
                    required={true}
                    rules={[{ required: testType, message: 'Username is required' }]}>
					<Input placeholder='Username' />
				</Form.Item>
				<Form.Item
					className='mb-1'
					label='Password'
					name='password'
                    required={true}
                    rules={[{ required: testType, message: 'Password is required' }]}>
					<Input type='text' placeholder='Password' />
				</Form.Item>

				<div>
					<a
						href='https://eniture.com/bigcommerce-saia-connection-instructions/'
						target='_blank'
						rel='noreferrer'
					>
						How to obtain your SAIA account credentials?
					</a>
				</div>

				<Form.Item style={{ textAlign: 'right', marginBottom: '0' }}>
					<Space>
						<Button
							type='primary'
							size='large'
							htmlType='submit'
							name='test'
							onClick={() => handleTypeChange(true)}>
							Test Connection
						</Button>
						<Button
							type='primary'
							size='large'
							htmlType='submit'
							name='save'
							onClick={() => handleTypeChange(false)}>
							Save Settings
						</Button>
					</Space>
				</Form.Item>
			</Form>
		</Fragment>
	)
}

export default ConnectionSettingsComponent
